export const environment = {
	production: false,
	apiUrl:'https://access-control-v6.mango-api-dev.com/v1',
	secretKey: '47921864973276484792186497327648',
	ids: {
		pk: '01J8WYRV1NQQS38WSNC3P02EQV:module',
		sk: '01J8WYRV1P06ARH1FCHJQ9PJ8T:current',
	},
};
